import i18n from 'i18next'; /* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
// import ErrorIcon from './ErrorIcon';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.log('error: ', error);
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log('errorInfo: ', errorInfo);
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            flex: 1,
            textAlign: 'center',
            mt: 30,
            '& svg': {
              width: '100%',
              maxWidth: 400,
              color: (theme) => theme.palette.primary.main
            }
          }}
        >

          {/* <ErrorIcon /> */}
          <Typography
            variant="h2"
            component="h2"
            style={{ fontSize: 30, marginTop: 16 }}
          >
            {i18n.t('ErrorBoundary.pardon_bir\u015Feyler_yanl\u0131\u015F_gitti')}

          </Typography>
          <Typography style={{ fontSize: 18, marginTop: 12 }}>
            {i18n.t('ErrorBoundary.g\xF6z\xFCm\xFCzden_ka\xE7an_bir_hatay\u0131_buldunuz_mer')}

          </Typography>
          <Typography style={{ fontSize: 18 }}>
            {i18n.t('ErrorBoundary.sayfay\u0131_yenileyebilir_ya_da_daha_sonra_t')}

          </Typography>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;

ErrorBoundary.propTypes = {
  children: PropTypes.node
};
